import { useEffect, useState } from 'react'
import Pagination from '@material-ui/lab/Pagination'
import { useStyles } from './styles'
const NextPager = (props) => {
  const { totalcount, page, setPage } = props
  const [NoOffPages, setNoOfPages] = useState('1')
  useEffect(() => {
    setNoOfPages(Math.ceil(totalcount / 10))
  }, [totalcount])
  const classes = useStyles()
  return (
    <div className={classes.layout}>
      {' '}
      <Pagination
        page={page}
        count={NoOffPages}
        shape="rounded"
        size="medium"
        onChange={(event, newPage) => {
          setPage(newPage)
        }}
        // classes={{ root: classes.root }}
      />
    </div>
  )
}
export default NextPager
